import { PropsWithChildren, ReactNode } from 'react';

import OptionallyVisible from '../../optionallyVisible';
import { Container, Content, Controls, Header, Label } from './styles';

export interface PanelProps extends PropsWithChildren {
  className?: string;
  label?: string | ReactNode;
  controls?: ReactNode | ReactNode[];
}

export const Panel = ({ className, label, controls, children }: PanelProps) => {
  const isHeaderVisible = Boolean(label || controls);

  return (
    <Container className={className}>
      <OptionallyVisible visible={isHeaderVisible}>
        <Header>
          <Label>{label}</Label>
          <Controls>{controls}</Controls>
        </Header>
      </OptionallyVisible>
      <Content>{children}</Content>
    </Container>
  );
};
